import { Routes, Route } from 'react-router-dom';
import * as React from 'react';
import App from './App';
import { useSettingsQuery } from '../hooks/queries/useSettingsQuery';
import { useRouteTracking } from '../hooks/useRouteTracking';
import { useAuthenticatedUserTelemetry } from '../hooks/useAuthenticatedUserTelemetry';
import GlobalExceptionHandler from '../components/GlobalExceptionHandler/GlobalExceptionHandler';
import SplashScreen from '../components/SplashScreen';

import type { JSX } from 'react';

const RoutesComponent = (): JSX.Element => {
  useRouteTracking();
  useAuthenticatedUserTelemetry();
  useSettingsQuery();

  return (
    <GlobalExceptionHandler>
      <Routes>
        <Route
          path="/:port"
          element={
            <React.Suspense fallback={<SplashScreen />}>
              <App />
            </React.Suspense>
          }
        />
        <Route
          path="*"
          element={
            <React.Suspense fallback={<SplashScreen />}>
              <App />
            </React.Suspense>
          }
        />
      </Routes>
    </GlobalExceptionHandler>
  );
};

export default RoutesComponent;
